import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { useNavigate } from "react-router-dom";
import {
  encryptString,
  createSession,
  getAbhaProfile,
  verifyUser,
} from "../../services/apiUtils";
import Loader from "../../components/common/Loader";
import { ToastContainer, toast } from "react-toastify";

const ForgoatMobileNumber = () => {
  const [mobile, setMobile] = useState("");
  const [step, setStep] = useState("mobile");
  const [otpTextValue, setOtpTextValue] = useState("");
  const [txnId, setTxnId] = useState("");
  const [resendTimer, setResendTimer] = useState("");
  const [userDetails, setUserDetails] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    dob: "",
    gender: "Male",
  });
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [accessToken, setAccessToken] = useState("");
  const [captchaValue, setCaptchaValue] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaSessionId, setCaptchaSessionId] = useState("");
  const [captchaImage, setCaptchaImage] = useState("");
  const [showMobile, setShowMobile] = useState(false);
  const [formatedMobile, setFormatedMobile] = useState("");
  const [resendCount, setResendCount] = useState(1);
  const [mobileError, setMobileError] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [otpError, setOtpError] = useState("");

  const navigate = useNavigate();
  const back = () => {
    setResendCount(1);
    navigate("/abha-home");
  };

  // Generate captcha on mount
  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/abha/captcha/generate`);
      if (response.data.success) {
        setCaptchaSessionId(response.data.data.sessionId);
        setCaptchaImage(response.data.data.captchaImage);
        setCaptchaInput("");
      } else {
        toast.error("Failed to generate captcha. Please try again.");
      }
    } catch (error) {
      console.error("Error generating captcha:", error);
      toast.error("Failed to generate captcha. Please try again.");
    }
  };

  const handleMobileChange = (e) => {
    const inputValue = e.target.value;

    if (showMobile) {
      // When visible, extract numeric values directly
      const numericValue = inputValue.replace(/[^0-9]/g, "");
      const limitedValue = numericValue.slice(0, 10);
      setMobile(limitedValue);
      setFormatedMobile(limitedValue);

      // Validate mobile number
      if (limitedValue.length === 0) {
        setMobileError("Mobile number is required");
      } else if (limitedValue.length < 10) {
        setMobileError("Mobile number must be 10 digits");
      } else {
        setMobileError("");
      }
    } else {
      // When masked, compare lengths to determine if adding or removing
      const currentLength = formatedMobile.length;
      const newLength = inputValue.length;

      if (newLength > currentLength) {
        // User is adding a digit - extract the new digit
        const newDigit = inputValue.replace(/[^0-9]/g, "").slice(-1);
        if (newDigit && mobile.length < 10) {
          const updatedValue = mobile + newDigit;
          setMobile(updatedValue);
          const maskedValue = updatedValue
            .split("")
            .map(() => "*")
            .join("");
          setFormatedMobile(maskedValue);
        } else {
          // No new digit, just restore the mask
          const maskedValue = mobile
            .split("")
            .map(() => "*")
            .join("");
          setFormatedMobile(maskedValue);
        }
      } else if (newLength < currentLength) {
        // User is removing a digit (backspace)
        const updatedValue = mobile.slice(0, -1);
        setMobile(updatedValue);
        const maskedValue = updatedValue
          .split("")
          .map(() => "*")
          .join("");
        setFormatedMobile(maskedValue);
      }

      // Validate mobile number for masked input
      const currentMobileLength =
        mobile.length + (newLength > currentLength ? 1 : -1);
      if (currentMobileLength === 0) {
        setMobileError("Mobile number is required");
      } else if (currentMobileLength < 10) {
        setMobileError("Mobile number must be 10 digits");
      } else {
        setMobileError("");
      }
    }
  };

  const toggleMobileVisibility = () => {
    setShowMobile(!showMobile);
    // Reformat the display
    if (!showMobile && mobile) {
      // Switching to visible - show full number
      setFormatedMobile(mobile);
    } else if (mobile) {
      // Switching to masked - show all asterisks
      const maskedValue = mobile
        .split("")
        .map(() => "*")
        .join("");
      setFormatedMobile(maskedValue);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleGenderChange = (gender) => {
    setUserDetails((prev) => ({
      ...prev,
      gender,
    }));
  };

  const handleSendOtp = async () => {
    if (!mobile || mobile.length !== 10) {
      toast.error("Please enter valid 10-digit mobile number");
      return;
    }

    // Validate captcha with backend
    if (!captchaInput || captchaInput.trim() === "") {
      toast.error("Please enter the captcha.");
      return;
    }

    try {
      // Verify captcha with backend
      const captchaResponse = await axios.post(
        `${API_BASE_URL}/abha/captcha/validate`,
        {
          sessionId: captchaSessionId,
          captcha: captchaInput,
        },
      );

      if (!captchaResponse.data.success || !captchaResponse.data.valid) {
        toast.error("Invalid captcha. Please try again.");
        generateCaptcha(); // Regenerate captcha
        setCaptchaInput(""); // Clear input
        return;
      }
    } catch (error) {
      toast.error("Failed to validate captcha. Please try again.");
      generateCaptcha();
      setCaptchaInput("");
      return;
    }

    try {
      setIsPageLoading(true);
      const encryptedMobile = await encryptString(mobile);
      // const sessionResponse = await createSession();
      //  const accessToken = sessionResponse?.accessToken;

      // if (!accessToken) {
      //   throw new Error("Access token not received from session");
      // }

      // setAccessToken(accessToken);

      const response = await axios.post(
        `${API_BASE_URL}/abha/forgot/mobile/send-otp`,
        {
          loginId: encryptedMobile,
        },
        {
          headers: {
            "Content-Type": "application/json",
            // accesstoken: `${accessToken}`,
          },
        },
      );

      const dtresponse = response.data;

      if (response.status === 200) {
        setTxnId(dtresponse.data.txnId);
        setStep("details_and_otp");
        toast.success(dtresponse?.data?.message);
        setResendTimer(60);
      }
    } catch (error) {
      setIsPageLoading(false);
      const errorMsg =
        error.response?.data?.error?.error?.message ||
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Server error occurred. Please try again later.";

      if (
        error.response?.data?.success === false &&
        error.response?.data?.message === "X-token expired"
      ) {
        toast.error(errorMsg);
      } else if (
        error.response?.data?.message === "Unclassified Authentication Failure"
      ) {
        toast.error(errorMsg + ". Please try again!");
      } else {
        toast.error(errorMsg);
      }
    } finally {
      setIsPageLoading(false);
    }
  };

  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => setResendTimer((prev) => prev - 1), 1000);
      return () => clearTimeout(timer); // Cleanup timer on unmount
    }
  }, [resendTimer]);

  const handleResendOtp = async () => {
    try {
      setIsPageLoading(true);
      const encryptedMobile = await encryptString(mobile);
      // const sessionResponse = await createSession();
      // const token = sessionResponse?.accessToken;

      // if (!token) {
      //   throw new Error("Access token not received from session");
      // }

      // setAccessToken(token);

      const response = await axios.post(
        `${API_BASE_URL}/abha/forgot/mobile/send-otp`,
        { loginId: encryptedMobile },
        {
          headers: {
            "Content-Type": "application/json",
            // accesstoken: `${token}`,
          },
        },
      );

      if (response.status === 200) {
        setTxnId(response.data.data.txnId);
        toast.success(
          response.data?.data?.message || "OTP resent successfully.",
        );
        setResendTimer(60);
      }
    } catch (error) {
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Server error occurred. Please try again later.");
      }
    } finally {
      setIsPageLoading(false);
    }
  };

  const handleOtpChange = (e) => {
    const value = e.target.value;
    // Allow only digits and up to 6 characters
    if (/^\d{0,6}$/.test(value)) {
      setOtpTextValue(value);
      // Validate OTP
      if (value.length === 0) {
        setOtpError("OTP is required");
      } else if (value.length < 6) {
        setOtpError("OTP must be 6 digits");
      } else {
        setOtpError("");
      }
    }
  };

  const validateUserDetails = (userDetails) => {
    if (!userDetails.firstName?.trim()) {
      toast.error("First name is required");
      return false;
    }

    if (!userDetails.lastName?.trim()) {
      toast.error("Last name is required");
      return false;
    }

    if (!userDetails.dob?.trim()) {
      toast.error("Date of Birth is required");
      return false;
    }

    if (!userDetails.gender?.trim()) {
      toast.error("Gender is required");
      return false;
    }

    return true;
  };

  const handleVerifyOtp = async () => {
    try {
      setIsPageLoading(true);

      // Validate required fields

      const isValid = validateUserDetails(userDetails);
      if (isValid) {
        const encryptedOtp = await encryptString(otpTextValue);
        // const sessionResponse = await createSession();
        // const token = sessionResponse?.accessToken;
        const response = await axios.post(
          `${API_BASE_URL}/abha/forgot/mobile/verify-otp`,
          {
            txnId: txnId,
            otp: encryptedOtp,
          },
          {
            headers: {
              "Content-Type": "application/json",
              // accesstoken: `${token || accessToken}`,
            },
          },
        );

        const dtresponse = response.data;
        if (dtresponse.success) {
          if (dtresponse.data.authResult === "success") {
            let account = null;

            if (
              dtresponse.data &&
              dtresponse.data.accounts &&
              dtresponse.data.accounts.length > 0
            ) {
              for (let i = 0; i < dtresponse.data.accounts.length; i++) {
                const acc = dtresponse.data.accounts[i];
                const nameParts = acc.name.split(" ");
                const apiFirstName = nameParts[0] || "";
                const apiLastName =
                  nameParts.length > 1 ? nameParts[nameParts.length - 1] : "";
                const apiMiddleName =
                  nameParts.length > 2 ? nameParts.slice(1, -1).join(" ") : "";

                let apiDob = acc.dob;
                let userDobFormatted = userDetails.dob;

                // Convert user's date from YYYY-MM-DD to DD-MM-YYYY
                if (userDetails.dob.includes("-")) {
                  const userDateParts = userDetails.dob.split("-");
                  if (
                    userDateParts.length === 3 &&
                    userDateParts[0].length === 4
                  ) {
                    userDobFormatted = `${userDateParts[2]}-${userDateParts[1]}-${userDateParts[0]}`;
                  }
                }

                const genderMatches =
                  (acc.gender === "M" && userDetails.gender === "Male") ||
                  (acc.gender === "F" && userDetails.gender === "Female") ||
                  acc.gender === userDetails.gender;

                const firstNameMatches =
                  apiFirstName.toLowerCase() ===
                  userDetails.firstName.toLowerCase();
                const lastNameMatches =
                  apiLastName.toLowerCase() ===
                  userDetails.lastName.toLowerCase();
                const middleNameMatches =
                  !userDetails.middleName || // User didn't enter middle name (optional)
                  (!apiMiddleName && !userDetails.middleName) ||
                  apiMiddleName.toLowerCase() ===
                    userDetails.middleName.toLowerCase();
                const dobMatches = apiDob === userDobFormatted;

                if (
                  firstNameMatches &&
                  lastNameMatches &&
                  middleNameMatches &&
                  dobMatches &&
                  genderMatches
                ) {
                  account = acc;
                  break; // Stop at first match
                }
              }

              if (account) {
                // Account matched, proceed to verify
                if (dtresponse.data?.token) {
                  const verifyUserObj = await verifyUser(
                    // token,
                    dtresponse.data.token,
                    account.ABHANumber,
                    dtresponse.data.txnId,
                  );

                  // Backend sets xToken cookie in the verifyUser response.
                  // Cookie is now available for the profile call.
                  if (verifyUserObj?.success) {
                    const abhaProfileData = await getAbhaProfile();

                    if (abhaProfileData?.success) {
                      toast.success(
                        dtresponse.data.message ||
                          "ABHA profile data fetched successfully.",
                      );
                      localStorage.setItem(
                        "orignalBeneficiaryData",
                        JSON.stringify(abhaProfileData.data),
                      );
                      localStorage.setItem(
                        "abhaProfileData",
                        JSON.stringify(dtresponse.data),
                      );
                      setTimeout(() => {
                        setIsPageLoading(false);
                        navigate("/abha-Card");
                      }, 3000);
                    } else {
                      toast.error(
                        abhaProfileData?.message ||
                          "Failed to fetch ABHA profile data. Please try again.",
                      );
                      setIsPageLoading(false);
                    }
                  } else {
                    setIsPageLoading(false);
                    toast.error("Something went wrong");
                  }
                } else {
                  setIsPageLoading(false);
                  toast.error(dtresponse.data?.message);
                }
              } else {
                // No matching account found
                setIsPageLoading(false);
                toast.error(
                  "Details do not match with any record. Please verify and try again.",
                );
              }
            } else {
              setIsPageLoading(false);
              toast.error("Unable to verify details. Please try again.");
            }
          } else {
            toast.error(
              dtresponse?.data?.message || "Wrong OTP. Please try again.",
            );
            setIsPageLoading(false);
            return;
          }
        } else {
          setIsPageLoading(false);
          toast.error("Unable to verify details. Please try again.");
        }
      } else {
        setIsPageLoading(false);
      }
    } catch (error) {
      setIsPageLoading(false);
      // Backend returned an error response
      if (
        error.response.data.success === false &&
        error.response.data.message === "Unclassified Authentication Failure"
      ) {
        toast.error(error.response.data.message + ". Please try again!");
      } else {
        toast.error(
          error.response.data.message ||
            "Server error occurred. Please try again later.",
        );
      }
    } finally {
      setIsPageLoading(false);
    }
  };
  return (
    <>
      <ToastContainer />
      {isPageLoading && <Loader />}
      <div className="flow-feilds">
        {step === "mobile" && (
          <>
            <div className="feilds">
              <label>
                Mobile number <span style={{ color: "red" }}>*</span>
              </label>
              <div style={{ position: "relative", width: "100%" }}>
                <input
                  type="text"
                  className="filds-form"
                  placeholder="+91"
                  value={
                    mobile
                      ? "+91 " + (showMobile ? formatedMobile : formatedMobile)
                      : ""
                  }
                  autoComplete="off"
                  onChange={(e) => {
                    // Remove +91 prefix if present
                    const value = e.target.value.replace("+91", "").trim();
                    handleMobileChange({ target: { value } });
                  }}
                  style={{ paddingRight: "40px", width: "100%" }}
                />
                <i
                  className="material-icons"
                  onClick={toggleMobileVisibility}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "20px",
                  }}
                >
                  {showMobile ? "visibility" : "visibility_off"}
                </i>
              </div>
              {mobileError && (
                <span
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "5px",
                    display: "block",
                  }}
                >
                  {mobileError}
                </span>
              )}
            </div>

            <div className="feilds" style={{ marginTop: "15px" }}>
              <label>
                Captcha <span style={{ color: "red" }}>*</span>
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "10px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#f0f0f0",
                    padding: "5px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    flex: 1,
                    textAlign: "center",
                    userSelect: "none",
                    minHeight: "60px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {captchaImage ? (
                    <img
                      src={captchaImage}
                      alt="Captcha"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  ) : (
                    <span style={{ color: "#999" }}>Loading captcha...</span>
                  )}
                </div>
                <i
                  className="material-icons"
                  onClick={generateCaptcha}
                  style={{ cursor: "pointer", fontSize: "24px" }}
                  title="Refresh Captcha"
                >
                  refresh
                </i>
              </div>
              <input
                type="text"
                className="filds-form"
                placeholder="Enter captcha text"
                value={captchaInput}
                onChange={(e) => {
                  setCaptchaInput(e.target.value);
                }}
                autoComplete="off"
              />
            </div>
          </>
        )}

        {step === "details_and_otp" && (
          <>
            {/* First Section: OTP Input */}
            <div style={{ marginBottom: "20px" }}>
              <div className="feilds">
                <label>Confirm OTP</label>
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    className="filds-form"
                    placeholder="Enter OTP"
                    maxLength={6}
                    value={otpTextValue}
                    onChange={handleOtpChange}
                    autoComplete="off"
                    style={{ paddingRight: "40px" }}
                  />
                  {otpTextValue.length === 6 && (
                    <i
                      className="material-icons"
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#4CAF50",
                        fontSize: "20px",
                      }}
                    >
                      check
                    </i>
                  )}
                </div>
                {otpError && (
                  <span
                    style={{
                      color: "#dc3545",
                      fontSize: "12px",
                      marginTop: "5px",
                      display: "block",
                    }}
                  >
                    {otpError}
                  </span>
                )}
                <span
                  className="notes text-end"
                  onClick={() => {
                    if (resendTimer === 0 && resendCount < 3) {
                      setResendCount(resendCount + 1);
                      handleResendOtp();
                    }
                  }}
                  style={{
                    pointerEvents:
                      resendTimer > 0 || resendCount >= 3 ? "none" : "auto",
                    color:
                      resendTimer > 0 || resendCount >= 3 ? "#999" : "#007bff",
                    cursor:
                      resendTimer > 0 || resendCount >= 3
                        ? "not-allowed"
                        : "pointer",
                    display: "block",
                    marginTop: "5px",
                  }}
                >
                  {resendTimer > 0
                    ? `00:${resendTimer < 10 ? "0" + resendTimer : resendTimer} Resend OTP (${3 - resendCount} ${3 - resendCount === 1 ? "attempt" : "attempts"} left)`
                    : resendCount >= 3
                      ? "Maximum resend attempts reached"
                      : `Resend OTP (${3 - resendCount} ${3 - resendCount === 1 ? "attempt" : "attempts"} left)`}
                </span>
              </div>
            </div>

            {/* Second Section: Personal Details */}
            <div
              style={{
                padding: "20px",
                borderRadius: "8px",
                margin: "0 -20px",
                width: "200%",
              }}
            >
              <h4
                style={{
                  color: "#1976D2",
                  fontSize: "16px",
                  fontWeight: "600",
                  marginBottom: "20px",
                  textAlign: "center",
                }}
              >
                Enter the below details as per Aadhaar details to proceed
              </h4>

              <div className="retrieve-adhar-details">
                <div className="row">
                  <div className="col-xs-12 col-md-4">
                    <div className="feilds">
                      <label>First name*</label>
                      <input
                        type="text"
                        className="filds-form"
                        placeholder="First name*"
                        name="firstName"
                        value={userDetails.firstName}
                        onChange={handleInputChange}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <div className="col-xs-12 col-md-4">
                    <div className="feilds">
                      <label>Middle name</label>
                      <input
                        type="text"
                        className="filds-form"
                        placeholder="Middle name"
                        name="middleName"
                        value={userDetails.middleName}
                        onChange={handleInputChange}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <div className="col-xs-12 col-md-4">
                    <div className="feilds">
                      <label>Last name*</label>
                      <input
                        type="text"
                        className="filds-form"
                        placeholder="Last name*"
                        name="lastName"
                        value={userDetails.lastName}
                        onChange={handleInputChange}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <div className="col-xs-12 col-md-4">
                    <div className="feilds">
                      <label>Date of birth *</label>
                      <input
                        type="date"
                        className="filds-form"
                        name="dob"
                        value={userDetails.dob}
                        onChange={handleInputChange}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <div className="col-xs-12 col-md-8">
                    <div className="feilds">
                      <label>Gender*</label>
                      <div className="gendareSection">
                        <label>
                          <input
                            type="radio"
                            className="filds-form"
                            name="gender"
                            checked={userDetails.gender === "Male"}
                            onChange={() => handleGenderChange("Male")}
                          />
                          Male
                        </label>
                        <label>
                          <input
                            type="radio"
                            className="filds-form"
                            name="gender"
                            checked={userDetails.gender === "Female"}
                            onChange={() => handleGenderChange("Female")}
                          />
                          Female
                        </label>
                        <label>
                          <input
                            type="radio"
                            className="filds-form"
                            name="gender"
                            checked={userDetails.gender === "Other"}
                            onChange={() => handleGenderChange("Other")}
                          />
                          Other
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      <div className="flow-feilds pb-3" style={{ minHeight: "auto" }}>
        <div className="feilds feildsBtn">
          <button className="custBtn btnCancel" onClick={back}>
            Back
          </button>
          <button
            className={`custBtn ${
              step === "mobile"
                ? mobile.length === 10 && captchaInput.length > 0
                  ? "btnSuccess"
                  : "disabled"
                : step === "details_and_otp"
                  ? otpTextValue.length === 6 &&
                    userDetails.firstName &&
                    userDetails.lastName &&
                    userDetails.dob &&
                    userDetails.gender
                    ? "btnSuccess"
                    : "disabled"
                  : "btnSuccess"
            }`}
            disabled={
              step === "mobile"
                ? mobile.length !== 10 || captchaInput.length === 0
                : step === "details_and_otp"
                  ? otpTextValue.length !== 6 ||
                    !userDetails.firstName ||
                    !userDetails.lastName ||
                    !userDetails.dob ||
                    !userDetails.gender
                  : false
            }
            onClick={
              step === "mobile"
                ? handleSendOtp
                : step === "details_and_otp"
                  ? handleVerifyOtp
                  : null
            }
          >
            {step === "mobile"
              ? "Send OTP"
              : step === "details_and_otp"
                ? "Verify OTP"
                : "Submit"}{" "}
            <i className="material-icons">arrow_right_alt</i>
          </button>
        </div>
      </div>
    </>
  );
};

export default ForgoatMobileNumber;
